import React from "react";
import "./catalog.css";

export default function CatalogPageShell({ title, subtitle, children }) {
    return (
        <div className="catalog-page">
            <header className="catalog-page-header">
                <h1>{title}</h1>
                {subtitle ? <p className="catalog-sub">{subtitle}</p> : null}
            </header>
            <div className="catalog-page-body">{children}</div>
        </div>
    );
}
